import { MutedAlert } from '@app/components/MutedAlert';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

export interface SocialExportUploadsPanoramaLayoutProps {
  /** Flattened uploads for the current entity. */
  uploadCount: number;
  hasAvailableSources: boolean;
  areConnectionsResolved: boolean;
  hasConnectedPlatforms: boolean;
  /** Shown inside MutedAlert while connections are still loading, or when there are platforms but no uploads yet. */
  notPublishedMessage: MessageDescriptor;
  noSourcesAlert: ReactNode;
  noPlatformsAlert: ReactNode;
  /** Rendered when there is at least one upload. */
  uploadList: ReactNode;
}

/**
 * Shared empty-state branching for fragment + composition social upload panoramas.
 */
export function SocialExportUploadsPanoramaLayout({
  uploadCount,
  hasAvailableSources,
  areConnectionsResolved,
  hasConnectedPlatforms,
  notPublishedMessage,
  noSourcesAlert,
  noPlatformsAlert,
  uploadList,
}: SocialExportUploadsPanoramaLayoutProps) {
  if (uploadCount === 0) {
    if (!hasAvailableSources) {
      return noSourcesAlert;
    }
    if (!areConnectionsResolved) {
      return (
        <MutedAlert sx={{ mt: 2 }}>
          <FormattedMessage {...notPublishedMessage} />
        </MutedAlert>
      );
    }
    if (!hasConnectedPlatforms) {
      return noPlatformsAlert;
    }
    return (
      <MutedAlert sx={{ mt: 2 }}>
        <FormattedMessage {...notPublishedMessage} />
      </MutedAlert>
    );
  }

  return <Stack spacing={2}>{uploadList}</Stack>;
}
